export default {
    activateuser: {
        headerLabel: 'ユーザーオンボーディング',
        accountActivation: 'アカウントアクティベーション',
        step1: {
            header: '私たちのプラットフォームへようこそ！',
            subHeader: 'あなたのカウントにつながる方法を選んでください。',
            description:
                'より簡単にログインするため、次のサービスのうち、少なくとも一つにご自身のアカウントを連携させることをお勧めします。',
            OR: 'または',
            emailAndPassword: 'ご自分のEmailをご利用ください',
        },
        step2: {
            header: 'Emailとパスワードをご利用ください。',
            description:
                'これはあなたのアカウントに紐づけられるメインのEmailです。卒業後もあなたのデータにアクセスできるよう大学のアドレスではないアドレスをお使いください。アカウント設定で当社からの通知メールを簡単に管理することができます。',
            invalidEmail: '提供されたEmailが有効ではありません。',
            passwordsNotMatch: 'パスワードは一致する必要があります',
            passwordDescription01:
                'アカウントセキュリティーのために新しいパスワード設定が必要です。以下を利用してパスワードを作成してください。',
            passwordDescription02: '最低８文字',
            passwordDescription03: '少なくともひとつの小文字(a-z)',
            passwordDescription04: '少なくともひとつの大文字(A-Z)',
            passwordDescription05: '少なくともひとつの数字又は特殊文字(0-9, !#$ etc)',
            passwordDescription06: '少なくとも6の特殊文字',
            repeatPassword: 'パスワードを繰り返す',
        },
        step3: {
            header: 'ユーザーをアクティブにしています',
            loadingHints: {
                0: 'ユーザーデータをローディングしています',
                1: '全ての準備をしています',
                2: '新しい可能性がすぐそこに',
                3: 'あともう少し！',
            },
            successHeader: 'あなたのアカウントの準備ができました！',
            successSubheader: '今すぐ限定機能にアクセスできます！',
            errorHeader: 'アカウントをアクティブにできませんでした。',
            ifWrongContact: '問題がありましたらサポートまでご連絡ください。',
            contactForHelp: 'ヘルプにお問い合わせください。',
            goBack: '戻る',
        },
    },
    assessments: {
        general: {
            checkMyProgress: '進捗をチェックする',
            getStarted: '始めよう！',
            getToKnowYourself: 'あなた自身を知る',
            getToKnowYourselfBold: '<strong>自分自身</strong>を知る',
            getToKnowYourFuture: 'あなたの未来を知る',
            getToKnowYourFutureBold: '<strong>未来</strong>を知る',
            openAssessments: 'アセスメントを開く',
            openAssessment: 'アセスメントを開く',
            unlock: 'テストをアンロックする',
            testYourself: '自己分析テストを受ける',
            takeTheFreeTests: '無料テストを受ける',
            youOwnThisProduct: 'このプロジェクトはあなたのものです',
            startTest: 'テストを始める',
            startTests: 'テストを始める',
            continue: '続ける',
            showReport: 'レポートを表示する',
            showYourReports: 'あなたのレポートを表示する',
            showYourReport: 'あなたのレポートを表示する',
            continueFreeTests: '無料テストを続ける',
            continueTheTest: 'テストを続ける',
            estimatedTime: '~ {min} 分',
        },
        landing: {
            section1: {
                title: '自己分析テストを受ける',
                description01:
                    'アセスメントセンターへようこそ-ここからあなたのキャリアパスが始まります。',
                description02:
                    'ここでは <strong>Aon アセスメント</strong>テストを受けることができます。このテストはあなたの才能や将来のキャリア準備ができているかをテストするもので、世界中のリクルーターが利用しています。',
                freemium: {
                    description:
                        'このテストを受けてあなたの強みを把握しスキルに関する有益なレポートを取得してください。',
                    price: '無料',
                    numTests: '3 テスト',
                    timeEstimated: '約27分',
                },
                premium: {
                    description:
                        'これは<strong>本物</strong>です。この3択テストを受けてあなたが進むべきキャリアパスを探求し、完全な候補者レポートを手に入れましょう。',
                    numTests: '3択テスト',
                    timeEstimated: '約60分',
                    sampleReport: '↓レポートサンプルをダウンロードする',
                    candidateReport: '候補者レポート',
                    candidateReportDescription:
                        'これらのテスト終了後、テスト結果に関する包括的概要が記載された完全な候補者レポートを取得することができます。この概要にはご自身のパーソナルスキルセットを向上させるためのヒント、注目すべきスキル、始めるのに最適な機会、次のステップなどが含まれます。',
                },
            },
            section2: {
                title: 'これらのテストが採用にどのように役に立つ？',
                t1: 'あなたの<strong>スキル</strong>を知る',
                t2: 'あなたの<strong>ポテンシャル</strong>を認識する',
                t3: '<strong>キャリアパス</strong>明確化する',
                t4: 'あなたの<strong>自信</strong>を強化する',
            },
            section3: {
                title: 'あなた自身の発展やキャリアを向上させるために自分の強みやキャリアチャンスについて知りましょう。',
            },
            section4: {
                title: '今すぐ競争相手の先を行こう',
                description:
                    'Deloitte、Siemens、Burger King、Vodafone、そしてP&Gのような企業に属する世界中のリクルーターが利用する評価を完成させることで',
            },
            section5: {
                title: 'よくある質問',
                thisPage: 'このページ',
                question01: {
                    q: 'Aon Assessmentsとは？',
                    a: 'Aonによる人材アセスメントは世界中の企業が業務に最も適した候補者を探すのに役立つ世界中で知られているテストです。人材アセスメントによってリクルーターは履歴書、学歴、大学の成績、大学のディプロマだけでは判断できない最適な候補者を探し出すことができます。\n                <br><br>\n                このソリューションは通常 <strong>リクルーター限定</strong>ですが、ここでは面接の前に練習をして結果を得る<strong>限定</strong>チャンスをご利用いただけます。このチャンスを得られる候補者はほとんどいません。利用しない手はありません！',
                },
                question02: {
                    q: 'この評価を受けるのに費用はかかりますか？',
                    a: '４つのテストを無料で受けることができますー<i>仕事に関連する行動</i>、<i>数的論理的思考</i>、 <i>演繹的論理的思考</i>、そして <i>帰納的論理的思考</i>です。これらのテストではスキルや才能を知ることができ、あなたの強みや弱みを把握する素晴らしい方法となっています。\n\n                <br><br>もしあなたの傾向に関する完全な概要を希望されるなら、プロによる最適なキャリアパスに関する考査を得て、将来の成功へ第一歩を進みましょう。その他にも79€で3択テストにアクセスし包括的な候補者レポートを取得することができます。 <br><br>更なるアクセスには<a href={premiumLink}>ここをクリック</a>してカードでお支払いくださいー安全安心のお支払方法を提供しています。\n ',
                },
                question03: { q: 'テストを受けるべき理由' },
                question04: {
                    q: 'テストの準備に何が必要ですか？',
                    a: '技術的に必要な条件と<a href={link} target="_blank">このページ</a>のアセスメントのために準備すべきことをご一読ください。満点を取るのに役に立つ資料もあります',
                },
                question05: {
                    q: 'これらアセスメントは他にどこで見ることができますか？',
                    a: '典型的なケースでは、リクルーターからこれらのテストを受験することが求められるかもしれません。それ以外にこれらのテストを利用する機会はないかもしれません。これは、あなたが実践し、自分自身と将来のキャリアについて認識を深めるための唯一の機会です。',
                },
                question06: {
                    q: '受験可能回数は？',
                    a: '受験可能回数は1回です。繰り返し受けることはできません！このチャンスを活かすために落ち着いたコンディションでテストを受けてください。テストを受ける前にテストの受験方法に関するスクリーンキャスト動画を見たり、また練習問題を解いてこのテストについて詳しく知りましょう。',
                },
                question07: {
                    q: 'このテストは何語で受けられますか？',
                    a: '\n               このテストは英語で作成されていますが、様々な言語から選択できるようなっています。受験可能言語を調べ、あなたが受験したい言語を選んでください。\n',
                },
                question08: {
                    q: '拡張テストの支払いをした後、期限はありますか？',
                    a: 'ありません！お支払い完了後、いつでも好きな時に拡張テストを受けることができます。準備の時間をしっかりとり、最適なタイミングでアセスメントをスタートしてください。',
                },
            },
        },
        center: {
            banner: {
                title: '進捗をチェックする',
                subtitle: 'キャリアアセスメントに関するあなたの進捗概要をご確認ください。',
                moreInfo: 'もっと知る',
                yourProgress: 'あなたの進捗',
                quote: '目標設定は見えないものを見えるものにする第一歩です。',
            },
            list: {
                timeEstimated: '約 {minutes} 分',
                freemium: {
                    intro: '\n                    これはあなたのパーソナルディベロップメントの第一歩です。<br />\n                    これらのテストを受けてあなたの強みを把握し、あなたの\n                    スキルに関する有益なレポートを取得しましょう。\n                      ',
                },
                premium: {
                    intro: '\n                    これは本物です。<br />このテストを受けてあなたが進むべきキャリアパスを見つけ、\n                    包括的な <strong>候補者レポート</strong>を獲得しましょう。\n                ',
                    description:
                        '\n                    あなたの<strong>候補者レポート</strong> は、テスト結果の包括的な\n                    概要を提供するものです。これには\n                    パーソナルスキルセット向上のための<strong>ヒント</strong>、あなたが注目すべき <strong>スキル</strong>、始めるべき\nベスト<strong>チャンス</strong>、\n                    <strong>次のステップ</strong>は何か、などが含まれます。\n   ',
                },
            },
            instruments: {
                344: {
                    name: '演繹的論理的思考',
                    description:
                        '知識を使うことや規則を適用することがどのくらい得意か、調べてみましょうーこのテストは分析力や問題解決能力を測るものです。',
                    estimatedTime: '9',
                },
                383: {
                    name: '帰納的論理的思考',
                    description:
                        '規則や相互関係を認識することは得意ですか？分析力や問題解決能力を測るこのテストでチェックしてみましょう。',
                    estimatedTime: '9',
                },
                390: {
                    name: '仕事に関連する行動',
                    description:
                        'あなたにはどんな雇用者タイプ特性がありますか？業務上のパーソナル特性を認識するこのテストを受けて見つけてください。',
                    estimatedTime: '30',
                },
                721: {
                    name: '数的論理的思考',
                    description:
                        'あなたは数字の計算が得意ですか？このテストでは、数値情報を理解し、論理的な結論を導き出す能力を測定します。',
                    estimatedTime: '9',
                },
                5392: {
                    name: 'ワーキングメモリー',
                    description:
                        'あなたはどれだけ集中力を維持できますか？このテストは、集中しにくい環境下で情報を処理し、記憶する能力を測定します。',
                    estimatedTime: '15',
                },
                82013: {
                    name: 'フレックステスト',
                    description:
                        'あなたの興味は何ですか？このアンケートは、あなたがどのようなキャリアパスを目指したいかを見極めるのに役立ちます。',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Aonアセスメントを始める',
            consent:
                '私はAonがこのアセスメントに関連する私のデータに責任があることを理解し、Aonの利用規約に同意します。\n               私はまた、Higheredが私のレポートを作成するために私の氏名をAonに提供することを同意します。',
            startTest: 'テストを始める',
            consentErrorTitle: 'コンセントエラー',
            consentErrorMessage:
                'コンセント提出中にエラーが発生しました。Emailアドレスを確認しましたか？',
        },
    },
    calendar: {
        header: 'カレンダー',
        myCalendar: 'マイカレンダー',
        noCalendar: 'あなたのキャリアサービスはカレンダー機能をまだアクティブにしていません。',
        goBackBtn: '戻る',
        calendarNotReady: '”マイカレンダー”機能は準備中です。近日公開！',
        noUpcomingAppointments: '予定されたアポイントメントはありません。',
        appointmentMissing: 'アポイントメントがアクティブではありません。',
        appointmentNotActive:
            '申し訳ありません。あなたが見ようとしたアポイントメントは存在しないかアクティブではないアポイントメントです。',
        appointmentNotHavingAvailability:
            '申し訳ありません。このアポイントメントは現在利用できません。また後でご確認ください。',
        appointmentMissingRules: 'アポイントメントは利用できません。',
        needToCompleteProfile: 'プロフィールを完成する',
        noUpcomingAppointmentsPleaseBook:
            'あなたのカレンダーをアンロックするためにアポイントメントを予約してください。',
        bookAppointment: 'アポイントメント予約する',
        bookAnotherAppointment: 'アポイントメントを予約する',
        attendedAppointments: '出席したアポイントメント',
        aboutAppointments: {
            header: 'アポイントメントについて',
            button: '概要',
            block1: { header: 'アポイントメントとは？' },
            block2: { header: '詳細はどこに問い合わせたらいいですか？' },
        },
        bookAnAppointment: 'アポイントメントを予約する',
        backToCalendarBtn: 'カレンダーに戻る',
        backToBookingBtn: 'アポイントメントリストに戻る',
        firstAvailable: '最初の利用可能',
        loadingAppointment: 'ローディング中',
        bookModal: {
            title: '予約を確認する',
            with: '●●と',
            confirm: '確認する',
            continue: '続ける',
            cancel: '閉じる',
            first: {
                title: 'これはあなたの初めてのアポイントメントです。',
                description:
                    'イベントのご案内を確実にお届けするために、このメールからパーソナルカレンダーへのアクセスをご確認ください。',
                ok: 'OK',
                wrongEmail: '間違ったEmailですか？',
            },
            changeEmail: {
                title: 'あなたのカレンダーEmailを選んでください。',
                inputPlaceholder: 'Emailを入力',
                ok: 'OK',
                back: 'デフォルトを利用する',
            },
            unknownErrorHeader: '予約時にエラーが発生しました',
            unknownErrorBody:
                '後ほど予約してください。問題が発生したらサポートにお問い合わせください。',
            confirmationHeader: 'アポイントメントの予約ができました！',
            bookedTheFollowing: '詳細：',
            emailWillBeSent: '●●にメールが送信されます',
            withConfirmation: '出席の確認をお願いします。',
        },
        dateDetailsModal: { title: '●●のアポイントメント' },
        completedYourProfile:
            'カレンダーシステムにアクセスするにはプロフィールを完成する必要があります。',
        toMyProfile: 'プロフィールを編集する。',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} があなたのプロフィールを見ようとしています。',
            content: 'この人とあなたのプロフィールをシェアしますか？',
            share: 'プロフィールをシェアする',
            reject: 'いいえ',
        },
    },
    companyDetail: {
        locations: {
            header: 'ロケーション',
            viewAll: '全て見る',
            noLocations: 'ロケーションなし',
            allLocations: '全てのロケーション',
        },
        jobModule: {
            header: 'トップ・ポジション',
            viewAllJobs: ' {companyName}の求人情報をすべて見る',
            noPositions: 'Higheredに現在掲載されている{companyName}の求人情報はありません。',
            defaultLabel: 'オープンポジション',
        },
        videos: {
            header: '動画',
            noVideos: '動画なし',
            noMoreVideos: '他に動画はありません',
            moreVideosFrom: ' {companyName}からの他の動画',
        },
        articles: {
            header: '記事',
            noArticles: '記事はありません',
            noMoreArticles: '他に動画はありません',
            moreArticlesFrom: ' {companyName}からの他の記事',
        },
    },
    components: {
        builders: {
            searchable: { create: '作成する' },
            yearMonthPicker: { defaultSelect: '月を選択する' },
            localeDropdown: {
                languages: { en: '英語', cn: '中国語', fr: 'フランス語' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: '学校のEmailを確認する',
                description:
                    '"あっという間のプロセスで\n                            だけのユニークな求人情報やスキル\n                            テスト、キャリアリソースへアクセスできるようになります。',
                verificationPending: '確認途中',
                weHaveSentAnEmail:
                    '\n                                について\n                                <strong>{studentEmail}</strong>へメールを送信しました。ご確認ください。多くの学校が\n                                受信メールに厳しい設定をしていますので、\n        迷惑メールフォルダを必ず確認してください。',
                verifyMe: '私を確認してください',
                resendVerifyEmail: '確認メールを再送する',
                cancelVerification: '確認をキャンセルする',
                emailSent: 'メールが送信されました',
                emailSentMessage:
                    'メールの送信が完了しました。メールを受信しない場合はsupport@highered.globalにお問合せください。',
                resendErrorTitle: 'メール再送信中にエラーが発生しました',
                resendErrorMessage:
                    '確認メールの再送信ができませんでした。support@highered.globalにお問合せください。',
                verificationCancelledTitle: '確認がキャンセルされました',
                verificationCancelledMessage: '確認のキャンセルが完了しました',
                cancelErrorTitle: 'キャンセル中にエラーが発生しました',
                cancelErrorMessage:
                    '確認をキャンセルできませんでした。support@highered.globalまでお問合せください。',
            },
            verifyModuleDialog: {
                title: 'あなたの学校のEmailを確認してください',
                university: '教育機関',
                studentEmail: 'あなたの教育機関のEmailアドレス',
                studentEmailPlaceholder: '教育機関Email',
                message: 'メッセージ',
                verify: '確認する',
                sendRequest: 'リクエストを送信する',
                verificationInProcess: '確認中',
                emailHasBeenSentTo:
                    '<strong>{email}</strong>にメールが送信されました。こちらの説明にしたがって <strong>{schoolName}</strong>へのつながりを確認してください。',
                verificationRequestSentNonAcademic:
                    '<strong>{schoolName}</strong>のキャリアサービスはあなたのつながりを確認する必要があります。確認が必要な場合メールで通知されます。',
                ifNoEmailRecieved: '確認メールを受け取っていない方はお問合せください。',
                contactHelp: '問い合わせる',
                doNotHaveAcademicEmail: '私は教育機関のEmailを持っていません',
                doubleCheckEmail:
                    'このメールアドレスが正しく、アクセス権限を持っていることを再度確認してください。',
                haveAcademicEmail: '私は教育機関のメールアドレスを持っています',
                noAcademicEmailInfo:
                    '教育機関のメールアドレスを使用していない場合は、キャリアサービスが手動でリクエストを承認する必要があります。そのため、身元確認のための短いメッセージを入力する必要があります。',
                alreadyVerifiedInfo: 'あなたはこの学校ですでに確認されています。',
            },
        },
        navigation: {
            navigation: {
                myPage: 'マイページ',
                jobs: '求人',
                companies: '企業',
                masterclasses: 'マスタークラス',
                assessments: 'アセスメント',
                countryGuides: '国ガイド',
                goToHaigui: '中国での仕事',
                signIn: 'ログイン / サインアップ',
                vfairs: 'バーチャルイベント',
                events: 'イベント',
                newFeature: '新機能！',
            },
            profileNavigation: { signOut: 'サインアウト' },
            sidebar: {
                myPage: 'マイページ',
                myProfile: 'マイプロフィール',
                findJobs: '仕事を探す',
                findCompanies: '企業を探す',
                masterclasses: 'マスタークラス',
                assessments: 'アセスメント',
                countryGuides: 'カントリーガイド',
                goToHaigui: '中国での仕事',
                virtualFairs: 'バーチャルイベント',
                logOut: 'ログアウト',
            },
            backToCalendar: 'カレンダーに戻る',
            allBooths: '全てのブース',
            home: 'ホーム',
        },
        smart: {
            companyModule: {
                followJob: 'お気に入りに追加',
                followCompany: '企業をフォローする',
                unFollowJob: 'お気に入りから削除',
                unFollowCompany: '企業をアンフォローする',
                favoritedTitle: 'お気に入りに保存されました',
                favoritedMessage:
                    'この求人がお気に入りに保存されました。マイページでお気に入りの求人を見つけてください。',
                unfavoritedTitle: 'お気に入りから削除されました',
                unfavoritedMessage: 'この求人はお気に入りから削除されました',
                favoriteErrorTitle: '問題が発生しました',
                favoriteErrorMessage: 'この求人をお気に入りに登録できませんでした',
                showAllCompanies: '全ての企業を表示する',
                showOnlyCompaniesLiveOnChat: 'ライブチャット中の企業のみ表示する',
            },
            profileModule: {
                profileCompletion: 'プロフィール完成',
                profileCompletionEncouragement:
                    '残り{percentageLeft}のプロフィールを完成させ、採用者に自己紹介しましょう。',
                gotoProfilePage: 'プロフィールをアップデートする',
                profileCompleted: 'プロフィール完成',
                profileCompletedWhatsNext:
                    'ほとんどの採用担当者がオンラインアセスメントを採用プロセスで利用していることをご存知ですか？今すぐ実践してあなたの強みと弱みを把握しましょう。',
                gotoTestsPage: 'アセスメントセンターへ行く',
                authIndication: {
                    title: 'あなたの夢の仕事を見つける',
                    description:
                        'あなたの学校限定の求人や、就職活動を有利に進めるためのテストにアクセスしたいと思いませんか？今すぐGoogle、LinkedIn、Facebookアカウントを使って簡単にユーザー登録しましょう。',
                    action: 'さあ行ってみましょう',
                },
                toProfileHint: 'マイプロフィールへ',
                toProfileUncompletedHint:
                    'あなたのプロフィールは100％完成していません。採用可能性を最大化するため是非完成させてください。',
                profileActions: {
                    addFirstName: '名前を入力',
                    addLastName: '苗字を入力',
                    addNationality: '国籍を入力',
                    addPhoneNumber: '電話番号を入力',
                    addLanguage: '言語を入力',
                    addEducation: '教育を入力',
                    addEmail: 'メールアドレスを入力',
                    addGender: 'ジェンダーを入力',
                },
            },
            featuredCompanies: { label: '注目の企業' },
            featuredPositions: { label: '注目のポジション' },
            featuredResource: {
                header: 'バーチャルコンフェレンスに参加',
                cta: '今すぐ見て！',
                wechatSignupHeader:
                    'アップデート情報を得るためにHigheredのWeChatアカウントをフォローする ',
            },
        },
    },
    cts: {
        filterNames: {
            employment_types: '雇用タイプ',
            education_level: '学位',
            job_category: '分野',
            address: 'ロケーション',
            sector: '部門',
            exclude_school_id: '除外する',
            languages: '言語',
        },
        excludeSchoolIds: {
            '-1': 'シェアされたポスト',
            unknownSchoolId: 'EFMDスクールパートナー',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: '学士',
            MASTERS_OR_EQUIVALENT: '修士',
            DOCTORAL_OR_EQUIVALENT: '博士',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'フルタイム',
            INTERN: 'インターンシップ',
            TEMPORARY: 'パートタイム',
            PART_TIME: 'パートタイム',
        },
        startDate: '始める',
        educationFields: {
            ACCOUNTING_AND_FINANCE: '経理、財務',
            ADMINISTRATIVE_AND_OFFICE: '総務、事務',
            ADVERTISING_AND_MARKETING: '公告、マーケティング',
            ART_FASHION_AND_DESIGN: 'アートファッション、デザイン',
            BUSINESS_OPERATIONS: 'ビジネスオペレーション',
            COMPUTER_AND_IT: 'コンピューター、IT',
            CUSTOMER_SERVICE: 'カスタマーサービス',
            EDUCATION: '教育',
            HEALTHCARE: 'ヘルスケア',
            HUMAN_RESOURCES: '人事',
            INSTALLATION_MAINTENANCE_AND_REPAIR: '施設メンテナンス、修理',
            LEGAL: '法務',
            MANAGEMENT: 'マネージメント',
            MANUFACTURING_AND_WAREHOUSE: '製造、倉庫管理',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'メディアコミュニケーション、ライティング',
            OIL_GAS_AND_MINING: 'エネルギー',
            PROTECTIVE_SERVICES: '保護サービス',
            REAL_ESTATE: '不動産',
            SALES_AND_RETAIL: '営業、小売',
            SCIENCE_AND_ENGINEERING: '科学、エンジニアリング',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'ソーシャルサービス、非営利',
            TRANSPORTATION_AND_LOGISTICS: '運輸、物流',
        },
        sectors: {
            Consulting: 'コンサルタント',
            'Consumer Goods': '消費者製品',
            'Financial Services / Banking': 'ファイナンシャルサービス/銀行',
            'Goverment / Public Administration / Non Profit': '政府/行政/非営利団体',
            'International Trade & Development': '国際貿易・開発',
            Manufacturing: '製造',
            'Media / Entertainment': 'メディア/エンターテインメント',
            'Petroleum / Energy': '石油/エネルギー',
            'Pharma / Healthcare / Biotech': '製薬/ヘルスケア/バイオテック',
            'Real Estate / Construction / Infrastructure': '不動産/建設/インフラ',
            'Technology (IT) / Telecom': 'テクノロジー(IT)/電気通信',
            'Transportations & Logistics': '輸送&物流',
            Other: 'その他',
        },
        countries: {
            'China (Hong Kong SAR)': '香港',
            'Costa Rica': 'コスタリカ',
            'Europe & Sub-Saharan Africa': '欧州・サブサハラ・アフリカ',
            'Hong Kong': '香港',
            'Korea, South': '韓国',
            'New Zealand': 'ニュージーランド',
            'Papua-Ny Guinea': 'パプアニューギニア',
            'Puerto Rico': 'プエルトリコ',
            'Saudi Arabia': 'サウジアラビア',
            'South Africa': '南アフリカ',
            'South Korea': '韓国',
            'Sri Lanka': 'スリランカ',
            'Taiwan (Province of China)': '台湾',
            'The Seychell Islands': 'セイシェル',
            'United Arab Emirates': 'アラブ首長国連邦',
            'United Kingdom': '英国',
            'Ivory Coast': 'コートジボワール',
            Afghanistan: 'アフガニスタン',
            Algeria: 'アルジェリア',
            Angola: 'アンゴラ',
            Argentina: 'アルゼンチン',
            Armenia: 'アルメニア',
            Australia: 'オーストラリア',
            Austria: 'オーストリア',
            Azerbaijan: 'アゼルバイジャン',
            Bahamas: 'バハマ',
            Bahrain: 'バーレーン',
            Bangladesh: 'バングラデシュ',
            Belarus: 'ベラルーシ',
            Belgium: 'ベルギー',
            Botswana: 'ボツワナ',
            Brazil: 'ブラジル',
            Bulgaria: 'ブルガリア',
            Cambodia: 'カンボジア',
            Canada: 'カナダ',
            Chile: 'チリ',
            China: '中国',
            Colombia: 'コロンビア',
            Congo: 'コンゴ',
            Croatia: 'クロアチア',
            Cyprus: 'キプロス',
            Czechia: 'チェコ',
            Denmark: 'デンマーク',
            Ecuador: 'エクアドル',
            Egypt: 'エジプト',
            Estonia: 'エストニア',
            Ethiopia: 'エチオピア',
            Fiji: 'フィジー',
            Finland: 'フィンランド',
            France: 'フランス',
            Germany: 'ドイツ',
            Ghana: 'ガーナ',
            Greece: 'ギリシャ',
            Guernsey: 'ガーンジー',
            Hungary: 'ハンガリー',
            Iceland: 'アイスランド',
            India: 'インド',
            Indonesia: 'インドネシア',
            Iraq: 'イラク',
            Ireland: 'アイルランド',
            Israel: 'イスラエル',
            Italy: 'イタリア',
            Japan: '日本',
            Jersey: 'ジャージー',
            Jordan: 'ヨルダン',
            Kazakhstan: 'カザフスタン',
            Kenya: 'ケニア',
            Kuwait: 'クウェート',
            Laos: 'ラオス',
            Latvia: 'ラトビア',
            Lebanon: 'レバノン',
            Lithuania: 'リトアニア',
            Luxembourg: 'ルクセンブルク',
            Malaysia: 'マレーシア',
            Malta: 'マルタ',
            Mauritania: 'モーリタニア',
            Mauritius: 'モーリシャス',
            Mexico: 'メキシコ',
            Mongolia: 'モンゴル',
            Morocco: 'モロッコ',
            Myanmar: 'ミャンマー',
            Namibia: 'ナミビア',
            Netherlands: 'オランダ',
            Nigeria: 'ナイジェリア',
            Norway: 'ノルウェー',
            Oman: 'オマーン',
            Pakistan: 'パキスタン',
            Panama: 'パナマ',
            Paraguay: 'パラグアイ',
            Peru: 'ペルー',
            Philippines: 'フィリピン',
            Poland: 'ポーランド',
            Portugal: 'ポルトガル',
            Qatar: 'カタール',
            Romania: 'ルーマニア',
            Russia: 'ロシア',
            Senegal: 'セネガル',
            Serbia: 'セルビア',
            Singapore: 'シンガポール',
            Slovakia: 'スロバキア',
            Slovenia: 'スロベニア',
            Spain: 'スペイン',
            Sudan: 'スーダン',
            Swaziland: 'スワジランド',
            Sweden: 'スウェーデン',
            Switzerland: 'スイス',
            Syria: 'シリア',
            Taiwan: '台湾',
            Tanzania: 'タンザニア',
            Thailand: 'タイ',
            Tonga: 'トンガ',
            Turkey: 'トルコ',
            Ukraina: 'ウクライナ',
            Ukraine: 'ウクライナ',
            USA: 'アメリカ合衆国',
            Uzbekistan: 'ウズベキスタン',
            Vanuatu: 'バヌアツ',
            Vietnam: 'ベトナム',
            Zambia: 'ザンビア',
        },
        languages: {
            Aceh: 'アチェ州',
            Afrikaans: 'アフリカーンス語',
            Albanian: 'アルバニア語',
            Amharic: 'アムハラ語',
            Arabic: 'アラビア語',
            Arakanese: 'ラカイン語',
            Armenian: 'アルメニア語',
            Azeri: 'アゼルバイジャン語',
            Badini: 'バディーニ語',
            Basque: 'バスク語',
            Belarusian: 'ベラルーシ語',
            Bengali: 'ベンガル語',
            Berber: 'ベルベル語',
            Bosnian: 'ボスニア語',
            Bulgarian: 'ブルガリア語',
            Burmese: 'ビルマ語',
            Cantonese: '広東語',
            Catalan: 'カタルーニャ語',
            Cebuano: 'セブアノ語',
            Chechen: 'チェチェン語',
            Chin: 'チン語',
            Chinese: '中国語',
            Croatian: 'クロアチア語',
            Czech: 'チェコ語',
            Danish: 'デンマーク語',
            Dari: 'ダリー語',
            Dutch: 'オランダ語',
            English: '英語',
            Estonian: 'エストニア語',
            Faroese: 'フェロー語',
            Filipino: 'フィリピン語',
            Finnish: 'フィンランド語',
            French: 'フランス語',
            German: 'ドイツ語',
            Greek: 'ギリシャ語',
            Greenlandic: 'グリーンランド語',
            Hausa: 'ハウサ語',
            Hebrew: 'ヘブライ語',
            Hindi: 'ヒンディー語',
            Hungarian: 'ハンガリー語',
            Icelandic: 'アイスランド',
            Indonesian: 'インドネシア語',
            Italian: 'イタリア語',
            Japanese: '日本語',
            Kazakh: 'カザフスタン語',
            Kinyarwanda: 'キニヤルワンダ語',
            Kirundi: 'キルンディ語',
            Korean: '韓国語',
            Kurdish: 'クルド語',
            Kurmanji: 'クルマンジー',
            Kven: 'クヴェン語',
            Latin: 'ラテン語',
            Latvian: 'ラトビア語',
            Lingala: 'リンガラ語',
            Lithuanian: 'リトアニア語',
            Macedonian: 'マケドニア語',
            Malagasy: 'マラガシ語',
            Malaysian: 'マレーシア語',
            Mandarin: '北京語',
            Mongolian: 'モンゴル語',
            Nepali: 'ネパール語',
            Norwegian: 'ノルウェー語',
            Oromo: 'オロモ語',
            Other: 'その他',
            Panjabi: 'パンジャブ語',
            Pashto: 'パシュトゥ語',
            Persian: 'ペルシア語',
            Polish: 'ポーランド語',
            Portuguese: 'ポルトガル語',
            Punjabi: 'パンジャブ語',
            Romanes: 'ロマンス語',
            Romani: 'ロマ語',
            Romanian: 'ルーマニア語',
            Russian: 'ロシア語',
            Sami: 'サーミ語',
            Serbian: 'セルビア語',
            Sign_language: '手話',
            Slovak: 'スロバキア語',
            Slovene: 'スロベニア語',
            Somali: 'ソマリ語',
            Sorani: 'ソラニー',
            Spanish: 'スペイン語',
            Swahili: 'スワヒリ語',
            Swedish: 'スウェーデン語',
            Tagalog: 'タガログ語',
            Tamil: 'タミル語',
            Thai: 'タイ語',
            Tigrinya: 'ティグリニャ語',
            Turkish: 'トルコ語',
            Ukrainian: 'ウクライナ語',
            Urdu: 'ウルドゥー語',
            Uyghur: 'ウイグル語',
            Vietnamese: 'ベトナム語',
            Wolof: 'ウォロフ語',
        },
    },
    emailverification: {
        headerLabel: 'E-mail確認',
        verifyingEmail: 'E-mailを確認しています',
        emailVerifySuccess: 'E-mailが確認されました',
        emailVerifyFailure: '問題が発生しました。後ほど行うか、サポートにお問い合わせください。',
        gotoMyPage: 'マイページに戻る',
    },
    errors: {
        defaultErrorMessage: '問題が発生しました。',
        logInErrorText: {
            invalidCredentials: 'ユーザー名かパスワードが間違っています',
            inactiveUser:
                '提供されたメールアドレスのユーザーはアクティブではありません。アカウントアクティベーション用のメールアドレスを確認するか、パスワードをリセットしてください。',
            default: '本物であるか確認できませんでした',
        },
        registerErrorText: {
            passwordTooShort: 'パスワードは8桁以上でなければなりません。',
            emailAlreadyInUse: 'このアドレスは既に使われています',
            emailTaken:
                'すでに使用されているメールアドレスです。教育機関のメールを使用していた場合、プラットフォームがアップグレードされる前にユーザー登録があっためにこのようなことが起こる可能性があります（於：higheredtalent.org）。',
            default: 'ユーザーを作成できませんでした',
        },
        invalidTokenText: { default: 'トークンが無効か期限切れです' },
        passwordErrorText: {
            passwordTooShort: 'パスワードは8桁以上である必要があります',
            requireNonAlphanumeric:
                'パスワードは少なくとも１の特殊文字が使われている必要があります。',
            requireLowerCase: 'パスワードは少なくとも１の小文字が使われている必要があります。',
            requireUpperCase: 'パスワードは少なくとも１の大文字が使われている必要があります。',
            requireUniqueChars:
                'パスワードは少なくとも６の異なる文字が使われている必要があります。',
            default: 'パスワード変更ができませんでした',
        },
        recoverErrorText: {
            userNotFound: 'ユーザーが存在しません。サポートにお問い合わせください。',
            userAlreadyActive: 'ユーザーはアクティブになっています!\nログインしてください',
            emailAlreadyInUse:
                'すでに使用されているメールアドレスです。\nアカウントアクティベーションを進めたい場合、別のメールアドレスを使用するか、別のソーシャルログインを試してください。もしくは、ホームページに進み、アカウントにログインしてください。',
            default: 'アカウントをアクティブにできませんでした。\n後ほど試してください。',
        },
        socialAuthErrorText: {
            errorTitle: ' {provider}でログインできません',
            invalidProviderGoogle:
                '提供されたメールアドレスのユーザーはGoogleに連携されていません。例えばLinkedIn、Facebook、またはEmailでログインしてみてください。',
            invalidProviderFacebook:
                '提供されたメールアドレスのユーザーはFacebookに連携されていません。Google, LinkedIn、またはEmailでログインしてみてください。',
            invalidProviderLinkedIn:
                '提供されたメールアドレスのユーザーはLinkedInに連携されていません。Google、Facebook、またはEmailでログインしてみてください。',
            invalidProviderWeChat:
                '提供されたメールアドレスのユーザーはWeChatに連携されていません。Google、Facebook、またはEmailでログインしてみてください。',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'このメールアドレスはすでに使用されています。プラットフォームがアップデートされる前 (於：higheredtalent.org)にユーザー登録をいていたからかもしれません。サポートにお問い合わせください。',
            invalidEmailDomain:
                'このアドレスのドメインが大学のドメインと一致しません。正しい大学名を選択してください。',
            existingConnection: 'ユーザーは提供された大学とすでにつながっています。',
            default: '確認が開始できませんでした',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'すでに使われているEmailです',
                default: 'アップデートできませんでした',
            },
        },
    },
    favorites: {
        header: 'お気に入り',
        active: 'アクティブ',
        expired: '期限切れ',
        expiresThisMonth: '応募期限　今月',
        expiresThisWeek: '応募期限　今週',
        expiresLater: '応募締切後　',
        noActiveFavorites: 'アクティブなお気に入り求人はありません',
        noExpired: '期限切れのお気に入り求人はありません',
    },
    findcompanies: { headerLabel: '企業を探す', companyListLabel: '企業' },
    findjobs: {
        header: '求人検索',
        changeFilters: 'フィルターを変更する',
        recruitmentModule: {
            body: 'あなたは採用担当者かキャリア専門家ですか、それとも学生人材の雇用に\n       関心があるだけですか？',
            createJob: '求人広告を作成するにはここをクリック',
        },
    },
    general: {
        documentTitle: 'グローバルな求人プラットフォーム',
        email: 'Email',
        password: 'パスワード',
        confirmPassword: 'パスワードを確認',
        loading: 'ローディング中',
        ok: 'OK',
        save: '保存',
        add: '追加',
        close: '閉じる',
        delete: '削除する',
        cancel: 'キャンセルする',
        done: '完了',
        continue: '続ける',
        back: '戻る',
        next: '次',
        finish: '終了',
        success: '成功',
        error: 'エラー',
        description: 'ディスクリプション',
        months: {
            0: '1月',
            1: '2月',
            2: '3月',
            3: '4月',
            4: '5月',
            5: '6月',
            6: '7月',
            7: '8月',
            8: '9月',
            9: '10月',
            10: '11月',
            11: '12月',
        },
        days: {
            0: '日',
            1: '月',
            2: '火',
            3: '水',
            4: '木',
            5: '金',
            6: '土',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: '確認が完了していないものをチェックしています',
                verifySchoolConnection:
                    'これらのリソースにアクセスするため、学校のつながりを確認する',
                logInToAccessMoreFeatures: '数多くのグローバルなキャリアチャンス',
            },
        },
        minutesShort: '分',
        poweredBy: 'Powered by',
    },
    gptw: {
        company: { alt: 'GPTW', tooltip: 'この企業は「働きがいのある会社」です' },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip: 'このポストは「働きがいのある会社」のものです。',
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName}は「働きがいのある会社」に認定されています',
                    readMore: 'クリックしてもっと読む',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: '応募期限',
            location: 'ロケーション',
            employmentType: '雇用形態',
            languageRequirements: '言語要件',
            workPermitRequirements: '就労許可要件',
            preferredEducationField: '望ましい教育分野',
            preferredEducationLevel: '望ましい教育レベル',
            jobTags: 'タグ',
            apply: '今すぐ応募する',
            verificationRequired: '応募にはあなたの学校のEmail確認が必要です',
            verificationRequiredHint: '応募にはあなたの学校のEmail確認が必要です',
            verificationPending: 'あなたはこの学校で確認途中のものがあります',
            verificationPendingHint: 'あなたはこの学校で確認途中のものがあります',
        },
        invalidJobAd: {
            caption:
                '申し訳ありません。この求人が見つかりません。エラーと思われる場合は下のchatboxからサポートにお問い合わせください。',
            btn: '他の求人を探す',
        },
    },
    mypage: {
        header: 'マイページ',
        suggestedPositions: '提案された求人',
        favoriteModule: {
            header: 'お気に入り求人',
            seeAll: '全て見る',
            noFavorites: 'アクティブなお気に入り求人はありません。',
        },
    },
    recoverpassword: {
        createPassword: '新しいパスワードを作成する',
        newPasswordLabel: '新しいパスワード',
        newPasswordPlaceholder: 'パスワード',
        confirmPasswordLabel: 'パスワードを確認する',
        confirmPasswordPlaceholder: 'パスワードを確認する',
        resetPasswordButton: 'パスワードをリセット',
        resettingPassword: 'パスワードをリセットしています',
        passwordsNotMatching: 'パスワードが違います',
    },
    recoveruser: {
        headerLabel: 'Higheredユーザーを回復する',
        accountActivation: 'アカウントアクティベーション',
        step1: {
            header: '私たちの新しいプラットフォームへようこそ！',
            subHeader: 'あなたのカウントにつながる方法を選んでください。',
            description:
                'より簡単にログインするため、次のサービスのうち、少なくとも一つにご自身のアカウントを連携させることをお勧めします。',
            OR: 'または',
            emailAndPassword: 'ご自分のEmailをご利用ください',
        },
        step2: {
            header: 'Emailとパスワード使う',
            description:
                'これはあなたのアカウントに紐づけられるメインのEmailです。卒業後もデータにアクセスできるよう大学のアドレスではないアドレスをお使いください。アカウント設定で当社からの通知メールを簡単に管理することができます。',
            invalidEmail: '提供されたメールアドレスは有効ではありません',
            passwordsNotMatch: 'パスワードが違います',
            passwordDescription01:
                'アカウントセキュリティーのために新しいパスワード設定が必要です。以下を利用してパスワードを作成してください。',
            passwordDescription02: '最低8文字',
            passwordDescription03: '少なくともひとつの小文字(a-z)',
            passwordDescription04: '少なくともひとつの大文字(A-Z)',
            passwordDescription05: '少なくともひとつの数字又は特殊文字(0-9, !#$ etc)',
            passwordDescription06: '少なくとも6の異なる文字',
            repeatPassword: 'パスワードを繰り返す',
        },
        step3: {
            header: 'ユーザーをアクティブにしています',
            loadingHints: {
                0: 'ユーザデータをローディングしています',
                1: '準備を整えましょう',
                2: '新しいチャンスがすぐそこに',
                3: 'あと少し！',
            },
            successHeader: 'あなたのアカウントの準備ができました！',
            successSubheader: '新しい限定機能にアクセスできます！',
            errorHeader: 'アカウントをアクティブにできませんでした。',
            ifWrongContact: 'ご不明点はサポートにお問い合わせください。',
            contactForHelp: 'ヘルプに問合せる',
            goBack: '戻る',
        },
    },
    resourcesInternal: {
        header: 'リソース',
        resourceTypeHeader: 'タイプ',
        resourceNoContent: 'あなたの学校はまだリソース機能をアクティベイトしていません。',
        resourceFolderNoContent: 'このフォルダに利用可能なリソースはありません',
        resourceTitleHeader: 'タイトル',
        resourcePublishDateHeader: '公開済み',
        searchPlaceholder: '名前またはキーワードで検索',
        cvTemplateHeader: 'HIGHERED履歴書テンプレート（ATS-FRIENDLY)',
        cvTemplateSubtitle: 'ここからダウンロード！',
    },
    shared: {
        userNavSection: {
            myPage: 'マイページ',
            myProfile: 'マイプロフィールへ',
            myTests: 'アセスメント',
            myApplications: '応募',
            myFavorites: 'お気に入り',
            resources: 'リソース',
            calendar: 'カレンダー',
            documents: '履歴書アップロード',
        },
        searchModule: {
            searchBar: { label: 'タイトルまたはキーワードで検索' },
            filters: { clearFilters: 'フィルターをクリアにする' },
            filterLimit: {
                title: 'フィルターのリミットに達しました',
                message: 'これ以上このタイプのフィルターは選べません。',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'ポジション',
                estimatedCount: '{totalCount}のca {count} ',
                knownCount: ' {totalCount}の{count} ',
                noMatchFound: 'あなたの基準にマッチするものが見つかりませんでした',
            },
            postItem: { applyBefore: '応募期限' },
            postCard: { deadline: '期限' },
        },
        loginModule: {
            emailVerificationTip: 'あなたの受信boxに届くまで数分かかります',
            noEmail: 'Emailがありませんか？迷惑メールフォルダを確認してください。',
            logIn: 'ログイン / サインアップ',
            socialAuthBtns: {
                continueWithFacebook: 'Facebookで続ける',
                continueWithGoogle: 'Googleで続ける',
                continueWithLinkedIn: 'LinkedInで続ける',
                continueWithWeChat: 'WeChatで続ける',
            },
            verifyEmail: {
                verifyYourEmail: 'あなたのEmailを確認してください。',
                weSentAnEmailTo: '●●へ確認メールをおくりました。',
                continueToSignIn: 'サインインへ進む',
                resendEmail: '確認リンクを再送する',
                newEmailSent: '新しいEmailが送信されました',
            },
            registerForm: {
                recommendation:
                    '\n卒業後もあなたのデータにアクセスできるようにr\n            学校のメールアドレスではなく個人のアドレスのご利用をおすすめします。',
                register: '登録',
                passwordsNotMatch: 'パスワードが一致しません',
            },
            logInPaper: {
                useEmail: 'またはあなたのEmailをご利用ください',
                noAccount: 'アカウントを持っていませんか？',
                signUp: 'サインアップ',
                logInToAccess: 'この機能にアクセスするためにログインしてください',
                showAllOptions: '全てのログインオプションを表示する',
                hideAllOptions: '表示を減らす',
            },
            logInForm: {
                logIn: 'ログイン / サインアップ',
                forgotPassword: 'パスワードをお忘れですか？',
            },
            forgotPassword: {
                title: 'パスワードリセットをリクエストする',
                description:
                    'ご心配なく。誰でも時々パスワードを忘れてしまいます。\n                Emailを入力してパスワードを再設定してください。               ',
                resetPassword: 'パスワードをリセット',
                emailSentTitle: 'ヘルプまでもうすぐです！',
                emailHasBeenSent:
                    'Please check your\n                            inbox.パスワードのリセット方法のご案内メールが\n                            <br>\n                            <strong>{email}</strong>\n                            <br>\n                            宛に送信されました。\n                            受信ボックスをご確認ください。',
                noEmail: 'メールがありませんか？',
                sendEmailOneMoreTime: 'もう一度メールを送る',
                resendErrorTitle: 'パスワード回復中にエラーが発生しました',
                resendErrorMessage:
                    'パスワード回復メールが送信できませんでした。正しいメールアドレスですか？',
            },
        },
        termsAndConds: {
            termsAndConditions: '利用規約',
            privacyPolicy: 'プライバシーポリシー',
            talentPanel: '学校/採用者？',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: '削除されました',
                deletedTitle: 'このポジションはもう利用できません',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'お探しのページがもう存在しないようです',
            goToHome: 'ホームページへ行く',
            contactus: 'お問い合せ',
        },
        chat: {
            liveNow: '今チャットライブ中です！',
            seeAll: '全て',
            schoolSpecificChats: 'クイックアクセス',
            help: 'ヘルプが必要ですか？',
            chatExistsLabel: 'チャットがあります',
        },
        countdown: {
            day: '日',
            days: '日',
            hour: '時間',
            hours: '時間',
            minute: '分',
            minutes: '分',
            second: '秒',
            seconds: '秒',
        },
    },
    spotlight: {
        header: 'マイプロフィール',
        saveChangesToSubmit: '変更を有効にするためにプロフィールを保存してください',
        saveChanges: '変更を保存',
        saveSuccessful: '変更が適切に保存されました。',
        personalDetails: {
            header: 'パーソナル詳細',
            firstName: '名前',
            lastName: '苗字',
            nationality: '国籍を入力',
            gender: 'ジェンダー',
            uploadProfileImage: '写真をアップロード',
            genderOptions: {
                male: '男性',
                female: '女性',
                other: 'その他',
                none: '回答したくありません',
                unknown: '非通知',
            },
            wrongFileTypeErrorHeader: '無効なファイルの種類です',
            wrongFileTypeErrorDescription: '画像のみアップロード可能です',
        },
        summary: { header: 'エクゼクティブサマリー' },
        contactDetails: {
            header: 'お問合せ詳細',
            contactEmail: 'お問合せEmail',
            phoneNumberHeader: '携帯電話番号',
            countryCode: '国別コード',
            phoneNumber: '電話番号を入力',
            invalidEmail: '入力されたEmailが有効ではありません',
            permanentEmail: 'メモ：この変更は永久的なものです。Emailを設定できるのは一度だけです。',
        },
        languages: {
            header: '言語',
            languageLabel: '言語',
            levelLabel: 'レベル',
            addLanguage: '新しい言語を追加する',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': '初歩的なレベル',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'ビジネスで使うには制限がある',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63':
                    'ビジネスで使う上でプロフェッショナルレベル',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': '完全にプロレベル',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'ネイティブまたはバイリンガルレベル',
            },
        },
        education: {
            header: '教育',
            addEducation: '教育を追加する',
            notGraduated: '卒業前',
            graduatedIn: '{date}に卒業',
            dialog: {
                addNewEducation: '新しい教育を追加する',
                degreeTitle: 'プログラム',
                institution: '機関',
                degreeType: '学位',
                fieldOfStudy: '研究分野',
                cannotFindField: '研究が見つかりません',
                studyStart: '開始月',
                studyEnd: '卒業月',
                invalidDegreeTitle: 'プログラムタイトルの入力が必要です',
                invalidSchool: '学校を選択してください',
                invalidStartDate: '開始日を選んでください。',
                invalidEndDate: '卒業日を選んでください。',
                invalidStudyPeriod: '開始日前に卒業することはできません',
                invalidDegreeField: '有効な研究分野を入力してください',
                invalidDegreeLevel: '有効な学位レベルを選択してください',
                selectStartDate: '開始日',
                selectEndDate: '卒業日',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': '学士',
                    '09f419fa-1517-41ce-970c-df0d073fc440': '修士',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'PHD',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': '農業＆林業',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': '応用科学と専門職',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': '芸術、デザイン＆建築',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'ビジネス＆マネージメント',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'コンピューターサイエンス＆IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': '経済',
                    '5c0432d4-9297-429a-85c4-3305d207764e': '教育＆トレーニング',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'エンジニアリング＆テクノロジー',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd': '環境研究＆地球科学',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'ホスピタリティ、レジャー＆スポーツ',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': '人文科学',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'ジャーナリズム＆メディア',
                    'a2744908-9521-4330-a07d-3680b058d0a6': '法律',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'マーケティング',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60':
                        'イノベーションとビジネスにおける科学修士号',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': '開発マネージメント修士',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'データサイエンスにおける科学修士',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': '医学＆健康',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'ファイナンスMS',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': 'インターナショナルビジネススタディMS',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'ビジネスアナリシスMS',
                    '7d832109-642a-4730-aada-26927eb683ee': 'マネージメントMS',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': '自然科学＆数学',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': '社会科学',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'その他',
                },
            },
        },
        workAuthorization: {
            header: '就労許可',
            addWorkAuthorization: '就労許可を追加する',
            implicitValue: 'あなたの国籍に基づく',
            dialog: {
                selectCountry: '国を選ぶ',
                addEuWorkAuthorization: 'EU就労許可を追加する',
            },
        },
        communication: {
            header: 'コミュニケーション',
            sendMeUpdatesDescription:
                'キャリアニュース、求人、企業の最新情報をメールで送ってください。',
        },
        errors: {
            imageUpload: {
                title: '画像をアップロードできませんでした。',
                message: '画像が大きすぎます！',
            },
        },
        exitDialog: {
            title: '保存されていない変更が失われます',
            message:
                '変更を変更せずにページから離れようとしています。ページから離れる前に保存しますか？',
            stayAction: 'このページに留まる',
            saveAction: 'プロフィールを保存する',
            continueAction: '保存しないで続ける',
        },
    },
    tests: {
        header: 'テスト',
        unauthorized:
            'テストは現在利用できないベータにあります。この機能にはまだアクセスできません。すぐに利用できるようになります！',
        error: 'テストロード中に問題が発生しました。後でもう一度試してください。',
        assessmentModule: { header: 'あなたのアセスメント' },
        completedYourProfile:
            'このアセスメントにアクセスするにはプロフィールを完成させる必要があります',
        toMyProfile: 'マイプロフィールを編集する',
    },
    vfair: {
        header: 'EFMDバーチャルイベント',
        activeNow: '進行中',
        visibilityPrivate: 'プライベート',
        visibilityNetwork: 'ネットワーク',
        visibilityOpen: 'オープン',
        interested: '登録する',
        attend: 'イベントに出席する',
        enterEvent: 'バーチャルイベントに入る',
        notinterested: 'もう興味がありません。',
        shownInterest: '登録済み',
        signUpToday: '今日サインアップしましょう！',
        vfairsInfo:
            '洗練された就職イベントのシミュレーション環境で、世界中の企業や組織とつながり、リクルーターと求職者がリアルタイムに交流することができます。ご興味のあるバーチャルイベントをクリックして、お知らせを受け取るために登録してください。',
        recruitingOrgs: '採用活動中の企業＆組織',
        preRegistered: 'プレ登録',
        prepareForTheFair: 'バーチャルイベントの準備をする',
        privateVFairHeader: 'キャンパスバーチャルイベント',
        privateVFairMessage:
            'このバーチャルイベントはEFMDスクールのプラットフォームで開催されるため、ここからアクセスすることはできません。',
        schoolNotJoinedNetworkEventMessage:
            'あなたの学校がまだこのバーチャルイベントに登録していない場合は、プログラムディレクターまたはキャリア部門に参加を依頼してください。',
        companyNotJoinedNetworkEventMessage:
            'あなたの組織は、このイベントでアクティブなバーチャルブースを持っていません。参加するためにHigheredにご連絡ください。',
        pavilions: 'パビリオン',
        general: 'ジェネラル',
        allCompanies: '全ての企業',
        lobby: 'ロビー',
        inviteCode: '招待コード',
        eventRequiresInvitation: 'このイベントは招待が必要です',
        haveCode: 'コードを持っています',
        checkCode: 'コードをチェックする',
        invalidCode: '無効なコード',
        registeredSuccessfully: '登録が完了しました',
        pavilionTabs: {
            home: 'ホーム',
            companies: '企業',
            articles: '記事',
            jobs: '求人',
            events: 'イベント',
        },
        events: {
            noEventsAvailable: '利用可能なイベントはありません。',
            showCompleted: '終了したショー',
            hideCompleted: '終了しているものを隠す',
            liveNow: 'ライブ中',
            joinTheEvent: 'イベントに参加する',
            addToCalendar: 'カレンダーに追加する',
        },
        links: {
            masterclasses: {
                header: 'マスタークラス',
                buttonCaption: 'マスタークラスを見る',
                description:
                    '”採用される履歴書の書き方”、”Linkedinプロフィールのこつ”や”給与交渉”など、キャリアパスの各ステージで役に立つトップクオリティのマスタークラスを用意しています！',
            },
            detailsmasterclass: { header: 'マスタークラスに出席する' },
            cv: {
                header: '履歴書テンプレート',
                buttonCaption: '履歴書テンプレートをダウンロード',
                description:
                    'HigheredのATS-friendlyな履歴書テンプレートにアクセスしてリクルーターへの印象を最大化しましょう。',
            },
            elevatorPitch: {
                header: 'エレベーターピッチチャレンジ',
                buttonCaption: 'ピッチを送る',
                description:
                    '”ピッチパーフェクトチャレンジ”をご利用ください！世界のトップ企業や団体の何百人ものリクルーターに、あなたの価値をアピールするチャンスです。',
            },
        },
        footerHeaders: {
            social: 'アップデートを知るためにフォローするしてください',
            sponsored: 'スポンサー●●',
            organized: 'オーガナイザー●●',
        },
        educationPopup: {
            step00: {
                header: '学歴をシェアする',
                subtitle: '続けるために、採用担当者にあなたのことをもっと知ってもらいましょう。',
                continueLabel: '私の学歴を追加する',
                leaveLabel: '解任する',
            },
            step01: { header: '学歴を教えてください' },
            step02: { loadingLabel: '少々お待ちください。' },
            step03: {
                header: '終了した学業',
                subtitle:
                    'プロフィールをシェアして、採用担当者にアピールすることができるようになりました。',
                continueLabel: '引き続きバーチャルイベントをお楽しみください',
            },
            error: {
                header: 'おっと！問題が発生しました。',
                subtitle: '学歴情報が保存できませんでした。後ほどもう一度トライしてください。',
            },
        },
    },
};
